import { FormikHelpers, FormikValues } from "formik";
import FormikStep from "modules/Forms/components/formikStep.component";
import FormikStepperProvider from "modules/Forms/components/formikStepperProvider.component";
import React, { FC, useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import PromoItemsService from "../services/promoItems.service";
import {
  NavLink,
  Navigate,
  useNavigate,
  useParams,
  useMatch,
  useLocation
} from "react-router-dom";
import * as yup from "yup";
import { toast } from "react-toastify";
import { useActiveUser } from "modules/User/activeUser";
import CreateStepOneContainer from "./createStepOne.container";
import CreateStepTwoContainer from "./createStepTwo.container";
import { PSL } from "../domains/psl.domain";
import {
  Alert,
  AlertTitle,
  Breadcrumbs,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import { NavigateNext } from "@mui/icons-material";
import { PromoItemRowSchema } from "../services/promoItems.schemas";
import { FormikStepperLastStepConfirmation } from "modules/Forms/components/formikStepper.component";
import { IUserScope, UserService } from "modules/User/service/user.service";
import { useStaticData } from "modules/MasterData/service/staticData.hooks";


const testVendorData = {
  pslId: null,
  promoCategoryId: null,
  promoCategoryQualityRequired: false,
  strategicBuyerEmailAddress: "test@test.com",
  teamName: "test",
  agreements: "agreements go here",
  validFrom: "2024-06-11T21:00:00.000Z",
  validTo: "2025-04-25T21:00:00.000Z",
  supplierCode: null,
  supplierName: null,
  childSupplierCode: "0100210002",
  childSupplierName: "Vb-Servicos Comercio E |City: MORUNGABA|",
  statusId: 2,
  pslVendorContactName: "Contact Name",
  pslVendorContactPhone: "Phone",
  pslVendorContactEmail: "Email",
  pslVendorContactUrl: "Website",
  noteRequester: "This is a note to requester",
  noteLocalProcurement: "This is a note to local procurement",
  tenderNumber: "tender number here",
  priceList: "http://www.example.com",
  zones: [],
  markets: [],
  companyCodes: [{ id: "1", name: "BR10 - Nestle Brasil Ltda", code: "BR10" }],
  plants: [],
  businessUnits: [{ id: 0, name: "All" }],
  relatedToEasyBuy: true,
  statusJustification: "Test justification",
  statusAttachments: [],
  yearlySpendCurrencyCode: "CHF",
  yearlySpend: null,
  scope: 3,
  createdByUser: null,
  marketContactName: null,
  parentId: null,
  qualityApprovers: ["test@test.com"],
  spendCat1Id: 1476,
  spendCat1DisplayValue: null,
  spendCat1Code: null,
  headerFiles: [],
  spendCat1Name: "[S39] 39 Marketing",
  incoTerms: "EXW",
};

export enum SupplierStatus {
  ALL = 0,
  MANDATORY = 1,
  SOLE_SOURCE = 2,
  VALIDATED = 3,
  BLANK = 4,
}
export const SelectBlank = { value: SupplierStatus.BLANK, label: "‎‎‎‎‏‏‎ ‎" };
export const SelectMandatory = {
  value: SupplierStatus.MANDATORY,
  label: "MANDATORY",
};
export const SelectSoleSource = {
  value: SupplierStatus.SOLE_SOURCE,
  label: "SOLE SOURCE",
};
export const SelectValidated = {
  value: SupplierStatus.VALIDATED,
  label: "VALIDATED",
};

export type CreatePromoItemContainerProps = {};

export const CreatePromoItemContainer: FC<CreatePromoItemContainerProps> = (
  props
) => {
  const { promoId } = useParams();
  const navigate = useNavigate();
  const activeUser = useActiveUser();
  const staticData = useStaticData();
  // const isPreview = useMatch("/catalogs/:promoId/view");
  // const isEdit = !!useMatch("/catalogs/:promoId/edit");
  const isReactivate = !!useMatch("/catalogs/reactivate/:promoId");
  // const isReadOnly = !!isPreview;


  const location = useLocation();

  const isEdit = location.pathname.endsWith("/edit");
  const isPreview = location.pathname.endsWith("/view");
  const isReadOnly = isPreview;
  const { data: pslInitialData, isLoading: pslLoading } = useQuery({
    queryKey: ["pslInitialData", promoId],
    queryFn: () => PromoItemsService.fetchPslInitialData({ pslId: promoId }),
    staleTime: 0,
    gcTime: 0,
    enabled: !!promoId,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });




  // useEffect(() => {
  //   if (!pslLoading && pslInitialData && isOrderWindowParentCatalog && isEdit && promoId) {
  //     navigate(`/catalogs/${promoId}/view`, { replace: true });
  //     toast.info("This catalog is read-only. Order Window parent catalogs cannot be edited.");
  //   }
  // }, [pslLoading, pslInitialData, isOrderWindowParentCatalog, isEdit, promoId, navigate]);

  const [defaultSpendCategories] = useState<any>({
    l1: null,
    l2: null,
    l3: null,
  });
  const [companyCodes, setCompanyCodes] = React.useState([]);

  const { data: userScope, isLoading: loadingUserScope } = useQuery({
    queryKey: ["userScope"],
    queryFn: () => UserService.fetchUserScope(false),
  });

  const createVendorsWithMaterialsMutation = useMutation({
    mutationFn: PromoItemsService.addPslVendorsWithMaterials,
    onSuccess: (data) => {
      toast.success(
        "Catalogue Record created successfully! ID:  " + data?.entity?.pslId
      );
      navigate(`/manage`);
    },
  });
  const localizeVendorsWithMaterialsMutation = useMutation({
    mutationFn: PromoItemsService.localizePslVendorsWithMaterials,
    onSuccess: (data) => {
      toast.success(
        `Catalogue Record localized successfully! ID:  ${data?.pslId}`
      );
      navigate(`/manage`);
    },
  });
  const updateVendorsWithMaterialsMutation = useMutation({
    mutationFn: PromoItemsService.updatePslVendorsWithMaterials,
    onSuccess: (data) => {
      toast.success(
        `Catalogue Record updated successfully! ID:  ${data?.res?.pslId}`
      );
    },
  });
  const updateChildPslWithMaterialsMutation = useMutation({
    mutationFn: PromoItemsService.updateChildPslWithMaterials,
    onSuccess: (data) => {
      toast.success(
        `Catalogue Record updated successfully! ID:  ${data?.pslId}`
      );
    },
  });

  const reactivatePslEntryMutation = useMutation({
    mutationFn: PromoItemsService.reactivatePslEntry,
    onSuccess: () => {
      toast.success(
        `Catalogue Record reactivated successfully! ID:  ${promoId}`
      );
    },
  });


  useEffect(() => {
    if (pslLoading || !pslInitialData) return;

    let materials: any[] = [];
    if (pslInitialData.materials?.data && pslInitialData.materials.data.length > 0) {
      materials = pslInitialData.materials.data.map((material: any) => ({
        ...material,
        hasTaxonomy:
          staticData.taxonomy.filter(
            (cat) => cat.spendCategoryL3?.id === (typeof material.spendCat3Id === 'string' ? parseInt(material.spendCat3Id, 10) : material.spendCat3Id)
          ).length > 0,
        priceRanges: Array.isArray(material.priceRanges) && material.priceRanges.length > 0
          ? material.priceRanges
          : [{ quantity: material.minimumOrderQuantity || 0, price: 0, pricePer: 1 }],
        mediaFiles: material.mediaFiles ?? [],
      }));
    }
    const vendor = pslInitialData.vendor;
    console.log("Vendor from API:", vendor.scope, vendor.discriminator);
    setInitialData({
      ...pslInitialData,
      vendor: {
        ...vendor,
        qualityApprovers: vendor.qualityApprovers ?? [],
      },
      materials, // Materials loaded here only if preloaded
      materialsTotal: pslInitialData.materials?.total, // Total may be set by step two
      materialsPage: 1,
      materialsTotalPages: undefined,
      materialsNeedsPagination: false,
      campaignRelated:
        pslInitialData.vendor?.statusJustification?.indexOf(
          "Order Campaign Number:"
        ) > -1,
    }); //TODO: change to values.vendor.orderWindowId when the BE is fixed
  }, [pslInitialData, pslLoading, staticData.taxonomy]);

  useEffect(() => {
    if (userScope) {
      const all = (userScope as IUserScope[]).filter(
        (item) => item.fullMarketAccess || item.companyCodes.length > 0
      );
      let markets = [];
      all.forEach(function (full) {
        markets[full.market.id] = full.companyCodes?.map(
          (company) => company.code
        );
      });
      setCompanyCodes(markets);
    }
  }, [userScope]);

  useEffect(() => {
    window.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && e.ctrlKey) {
        setInitialData((prevData) => ({
          ...prevData,
          vendor: { ...prevData.vendor, ...testVendorData },
        }));
        toast.info("Test data applied");
      }
    });
    return () => {
      window.removeEventListener("keydown", (e) => {
        if (e.key === "Enter" && e.ctrlKey) {
          setInitialData((prevData) => ({
            ...prevData,
            vendor: { ...prevData.vendor, ...testVendorData },
          }));
          toast.info("Test data applied");
        }
      });
    };
  }, []);
  // to send Array.
  const normalizePayload = (values: any) => {
    const { qualityApprover, ...restVendor } = values.vendor;

    return {
      ...values,
      vendor: {
        ...restVendor, // this keeps qualityApprovers
      },
    };
  };


  const isPslChild = (vendor: any) => {
    const psl = new PSL(vendor);
    return psl.isChildPsl();
  };

  const isPendingStatus = (status: number) => {
    return [0, 3, 5].includes(status);
  };

  const isChildPslWithPendingStatus = (vendor: any) => {
    return isPslChild(vendor) && isPendingStatus(vendor.pslStatus);
  };

  const [initialData, setInitialData] = useState({
    campaignRelated: false,
    vendor: {
      pslId: null,
      promoCategoryId: null,
      promoCategoryQualityRequired: false,
      // strategicBuyerEmailAddress: !activeUser.isEditorSupplier()
      //   ? activeUser.email
      //   : null,
      strategicBuyerEmailAddress: activeUser.isEditorSupplier()
        ? ""
        : activeUser.email,
      teamName: activeUser.jobTitle,
      agreements: null,
      validFrom: new Date().toISOString(),
      validTo: null,
      supplierCode: null,
      supplierName: null,
      childSupplierCode: null,
      childSupplierName: null,
      statusId: activeUser.isEditorSupplier() ? SupplierStatus.MANDATORY : null,
      pslVendorContactName: activeUser.isEditorSupplier()
        ? activeUser.name
        : null,
      pslVendorContactPhone: null,
      pslVendorContactEmail: activeUser.isEditorSupplier()
        ? activeUser.email
        : null,
      pslVendorContactUrl: null,
      noteRequester: null,
      noteLocalProcurement: null,
      tenderNumber: null,
      priceList: null,
      zones: [],
      markets: [],
      companyCodes: [],
      plants: [],
      businessUnits: [],
      relatedToEasyBuy: true,
      statusJustification: null,
      statusAttachments: [],
      yearlySpendCurrencyCode: null,
      yearlySpend: null,
      scope: +(activeUser.hasAboveMarketRole() && !promoId),
      createdByUser: null,
      marketContactName: null,
      parentId: null,
      qualityApprovers: [],
      spendCat1Id: null,
      spendCat1DisplayValue: null,
      spendCat1Code: null,
      headerFiles: [],
    },
    materials: [],
    materialsTotal: undefined as number | undefined,
    materialsPage: 1,
    materialsTotalPages: undefined as number | undefined,
    materialsNeedsPagination: false,
  });


  const formModeLabel = !promoId
    ? "Create"
    : isReactivate
      ? "Reactivate"
      : "Edit";
  const prefix = pslInitialData?.vendor?.pslIdWithPrefix ?? "";

  const isLP =
    prefix.startsWith("LP") || prefix.startsWith("OW_LP");

  const isCP =
    prefix.startsWith("CP") || prefix.startsWith("OW_CP");

  const isPP =
    prefix.startsWith("PP");

  const isOWPP =
    prefix.startsWith("OW_PP");

 const role = activeUser.getUserRole();

const canEdit =
  role === 1 || role === 6
    ? (isCP || isPP || isOWPP)
    : role === 0 || role === 5
    ? (isLP || isCP)
    : role === 8 && activeUser.isEditorSupplier()
    ? (isLP || isCP || isPP || isOWPP)
    : false;

  console.log("Apple:", {
    isEditorSupplier: activeUser.isEditorSupplier(),
    isAtMarket: activeUser.isAtMarket(),
    hasAboveMarketRole: activeUser.hasAboveMarketRole(),
    //pslIdWithPrefix: row.original.pslIdWithPrefix,
  });
  if (!pslLoading && isEdit && !canEdit) {
    toast.info(
      "You don't have permission to edit this catalog.",
      {
        toastId: "CATALOG_EDIT_BLOCK",
      }
    );

    return <Navigate to={`/catalogs/${promoId}/view`} replace />;
  }

  return !!promoId && (!pslInitialData || pslLoading) ? (
    <>loading...</>
  ) : (
    <>
      {pslInitialData?.vendor.rejectionComment && (
        <Alert severity="error" sx={{ mb: 4 }}>
          <AlertTitle>This catalog was REJECTED due to:</AlertTitle>
          {pslInitialData?.vendor.rejectionComment}
        </Alert>
      )}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Breadcrumbs
          separator={<NavigateNext fontSize="small" />}
          aria-label="breadcrumb"
        >
          {[
            <NavLink key="1" color="inherit" to="/manage" onClick={() => { }}>
              Catalogs
            </NavLink>,
            ...(initialData.vendor.parentId
              ? [
                <NavLink
                  key="2"
                  color="inherit"
                  to={`/catalogs/${initialData.vendor.parentId}/edit`}
                  onClick={() => { }}
                >
                  Catalogue Record #{initialData.vendor.parentId}
                </NavLink>,
              ]
              : []),
            <Typography key="3" color="text.primary">
              {promoId
                ? `Catalogue Record #${promoId}`
                : "New Catalogue Record"}
            </Typography>,
          ]}
        </Breadcrumbs>

        {isReadOnly && (
          <Button
            type="button"
            variant="contained"
            size="large"
            onClick={(e) => {
              e.preventDefault();
              navigate(`/catalogs/${promoId}/history`);
            }}
          >
            Catalog History
          </Button>
        )}
      </div>

      <FormikStepperProvider
        readOnly={isReadOnly}
        enableReinitialize
        title={`${formModeLabel} Catalogue Record ${promoId ?? ""}`}
        initialValues={initialData}
        validateOnChange={true}
        validateOnMount={false}
        validateOnBlur={true}
        onClose={() => navigate(-1)}
        onSubmit={async function (
          values: FormikValues,
          formikHelpers: FormikHelpers<FormikValues>
        ): Promise<any> {
          if (!promoId) {
            await createVendorsWithMaterialsMutation.mutateAsync(
              normalizePayload(values)
            );

            // await createVendorsWithMaterialsMutation.mutateAsync(payload);


          } else {
            const materialsWithPslId = (materials: any[]) =>
              materials.map((material: any) => ({
                ...material,
                pslId: promoId,
              }));

            if (isReactivate) {
              await reactivatePslEntryMutation.mutateAsync(
                normalizePayload({
                  ...values,
                  materials: materialsWithPslId(values.materials),
                })
              );

            } else {
              const isChild = isPslChild(values.vendor);
              const materialsToSend = materialsWithPslId(values.materials);

              if (isChild) {
                await updateChildPslWithMaterialsMutation.mutateAsync(
                  normalizePayload({
                    ...values,
                    materials: materialsToSend,
                  })
                );

              } else {
                await updateVendorsWithMaterialsMutation.mutateAsync(
                  normalizePayload({
                    ...values,
                    materials: materialsToSend,

                  }));
              }
            }
            navigate(`/manage`);
          }
        }}
        showStepper
        submitButtons={(
          submitForm,
          setFieldValue,
          loading,
          errors,
          values,
          formikContext
        ) => {
          const childPslWithPendingStatus = isChildPslWithPendingStatus(
            values.vendor
          );
          const isAboveMarketRole = activeUser.hasAboveMarketRole();
          const isEditing = !!promoId;
          const buttons: any[] = [];

          // Localize button visible only for AtMarket role and pending child PSL
          if (
            isEditing &&
            childPslWithPendingStatus &&
            !isAboveMarketRole &&
            !isReadOnly
          ) {
            buttons.push(
              <Button
                sx={{ marginRight: 1 }}
                variant="contained"
                onClick={async () => {
                  await localizeVendorsWithMaterialsMutation.mutateAsync(
                    normalizePayload({
                      ...values,
                      materials: values.materials.map((material) => ({
                        ...material,
                        pslId: promoId,
                      })),
                    })
                  );

                }}
                type="button"
                size="large"
                disabled={localizeVendorsWithMaterialsMutation.isPending}
                startIcon={
                  localizeVendorsWithMaterialsMutation.isPending ? (
                    <CircularProgress size={14} />
                  ) : null
                }
              >
                {localizeVendorsWithMaterialsMutation.isPending
                  ? "Localizing..."
                  : "Localize"}
              </Button>
            );
          }

          // Submit button - always visible, disabled when pagination is active in edit mode
          if (!isReadOnly) {
            const isChild = isPslChild(values.vendor);
            const isUpdating = isReactivate
              ? reactivatePslEntryMutation.isPending
              : isChild
                ? updateChildPslWithMaterialsMutation.isPending
                : updateVendorsWithMaterialsMutation.isPending;
            const isPaginationActive = !!values.materialsNeedsPagination;
            const totalPages = values.materialsTotalPages ?? 0;
            const isOnLastPage =
              !isPaginationActive ||
              (totalPages > 0 && values.materialsPage >= totalPages);

            buttons.push(
              <Button
                variant="contained"
                size="large"
                disabled={
                  loading ||
                  isUpdating ||
                  (!formikContext.dirty && !formikContext.isValid) ||
                  (isPaginationActive && !isOnLastPage)
                }
                type="submit"
                startIcon={loading ? <CircularProgress size={14} /> : null}
              >
                {loading ? "Submitting..." : "Submit"}
              </Button>
            );
          }

          return buttons;
        }}
        lastStepConfirmation={{
          text: "Quality Documents evidences are required for some Materials",
          title: "Are you sure to continue?",
          type: FormikStepperLastStepConfirmation.OkCancel,
        }}
      >
        <FormikStep
          title="Supplier information"
          validationSchema={yup.object().shape({
            vendor: yup.object().shape(
              {
                strategicBuyerEmailAddress: yup
                  .string()
                  .required("This field is required."),
                teamName: yup.string().required("This field is required."),
                childSupplierCode: yup
                  .string()
                  .required("This field is required."),
                childSupplierName: yup
                  .string()
                  .nullable()
                  .notRequired(),
                statusId: yup.number().required("This field is required."),
                statusJustification: yup.string().when("statusId", {
                  is: (statusId) =>
                    [
                      SupplierStatus.MANDATORY,
                      SupplierStatus.SOLE_SOURCE,
                    ].includes(statusId),
                  then: (schema) => schema.required("This field is required."),
                  otherwise: (schema) => schema.nullable().notRequired(),
                }),
                // qualityApprover: yup.string().notRequired(),
                qualityApprovers: yup.array().of(yup.string()).notRequired(),
                pslVendorContactName: yup.string().notRequired(),
                pslVendorContactUrl: yup.string().notRequired(),
                pslVendorContactEmail: yup.string().notRequired(),
                pslVendorContactPhone: yup.string().notRequired(),
                zones: yup
                  .array()
                  .test(
                    "zones",
                    "At least one location is required",
                    (value, ctx) => {
                      return (
                        ctx.parent.companyCodes.length > 0 ||
                        ctx.parent.markets.length > 0 ||
                        ctx.parent.zones.length > 0
                      );
                    }
                  ),
                markets: yup
                  .array()
                  .test(
                    "markets",
                    "At least one location is required",
                    (value, ctx) => {
                      return (
                        ctx.parent.companyCodes.length > 0 ||
                        ctx.parent.markets.length > 0 ||
                        ctx.parent.zones.length > 0
                      );
                    }
                  ),
                companyCodes: yup
                  .array()
                  .test(
                    "companyCodes",
                    "At least one location is required",
                    (value, ctx) => {
                      return (
                        ctx.parent.companyCodes.length > 0 ||
                        ctx.parent.markets.length > 0 ||
                        ctx.parent.zones.length > 0
                      );
                    }
                  ),
                //incoTerms: yup.string().required("This field is required."),
                incoTerms: yup.string().nullable().notRequired(),
                spendCat1Id: yup.string().required("This field is required."),
                businessUnits: yup.array().notRequired(),
                yearlySpendCurrencyCode: yup.string().notRequired(),
                validFrom: yup.date().nullable().notRequired(),
                validTo: yup.date().required("This field is required."),
                noteRequester: yup.string().notRequired(),
                noteLocalProcurement: yup.string().notRequired(),
                relatedToEasyBuy: yup.boolean().notRequired(),
                scope: yup.number().required("This field is required."),
              },
              [
                ["zones", "markets"],
                ["zones", "companyCodes"],
                ["markets", "companyCodes"],
              ]
            ),
          })}
        >
          <CreateStepOneContainer
            userScope={userScope}
            loadingUserScope={loadingUserScope}
            companyCodes={companyCodes}
          />
        </FormikStep>
        <FormikStep
          title="Materials"
          validationSchema={yup.object().shape({
            materials: yup
              .array()
              .of(PromoItemRowSchema)
              .min(1, "At least one material is required.")
              .test(
                "minimumOrderQuantity",
                "Quality Approver is required",
                (value, context) => {
                  const anyQualityRequired =
                    context.parent.vendor.parentId &&
                    context.parent.materials.some(
                      (m) =>
                        m.promoCategoryQualityRequired === true ||
                        m.promoCategoryQualityRequired === "true"
                    );
                  return anyQualityRequired
                    //  ? context.parent.vendor.qualityApprover != null
                    // : true;
                    ? Array.isArray(context.parent.vendor.qualityApprovers) &&
                    context.parent.vendor.qualityApprovers.length > 0
                    : true;
                }
              ),
          })}
        >
          <CreateStepTwoContainer
            defaultSpendCategories={defaultSpendCategories}
            companyCodes={companyCodes}
          />
        </FormikStep>
      </FormikStepperProvider>
    </>
  );
};

export default CreatePromoItemContainer;
